import request from "../../assets/js/Request.js";
// import qs from 'qs'

// 获取省市区
export const getAreas = (params) => {
  return request.get("regions?parentId=" + params);
};
// 获取医院
export const searchHospital = (params) => {
  return request.get(
    `hospitals?keyword=${params.keyword}&page=${params.page}&limit=${params.limit}`,
  );
};
